module.exports = __webpack_public_path__ + "media/v_kebab_ru.c453e286.mp4";